module.exports = __webpack_public_path__ + "static/media/news2.c2f0d348.jpg";